import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: { message: string } = { message: '' };

export const errorSlice = createSlice({
   name: 'error',
   initialState,
   reducers: {
      reduxUpdateError: (state, action: PayloadAction<string>) => {
         state.message = action.payload;
      },
   }
});

export const { reduxUpdateError } = errorSlice.actions;
export default errorSlice.reducer;